'use client';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { CategoryDetails, Category } from '../../../types';
import ServicesHighlights, {
    CategoryHighlightsProps,
} from '../services-highlights/ServicesHighlights';

type ServicesHighlightsCarouselProps = {
    categories: Array<CategoryDetails & Category>;
    classes?: string;
    speed?: number;
    slidesPerView?: number;
    spaceBetween?: number;
    /* carousel behaviour */
    infinite?: boolean;
    autoplay?: boolean;
    autoplayDelay?: number;
    alternate?: boolean;

    /* forwarded to ServicesHighlights */
    highlightsProps?: Omit<CategoryHighlightsProps, 'category'>;
};

const ServicesHighlightsCarousel = ({
                                        categories,
                                        classes = '',
                                        infinite = false,
                                        autoplay = false,
                                        alternate = false,
                                        slidesPerView= 1,
                                        speed = 600,
                                        spaceBetween = 30,
                                        autoplayDelay = 5000,
                                        highlightsProps = {},
                                    }: ServicesHighlightsCarouselProps) => {
    return (
        <div className={`relative w-full ${classes}`}>
            <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                    nextEl: '.services-highlights-next',
                    prevEl: '.services-highlights-prev',
                }}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
                speed={speed}
                loop={infinite}
                allowTouchMove
                autoplay={
                    autoplay
                        ? {
                            delay: autoplayDelay,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }
                        : false
                }
                className="services-highlights-swiper"
            >
                {categories.map((category, index) => (
                    <SwiperSlide key={`${category.id}-${index}`}>
                        <ServicesHighlights
                            alternate={alternate && index % 2 === 0}
                            category={category}
                            {...highlightsProps}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Navigation arrows */}
            <button
                className="services-highlights-prev absolute left-2 top-1/2 -translate-y-1/2 z-10
                           flex h-[45px] w-[45px] items-center justify-center
                           rounded-full bg-black/60 text-white
                           hover:bg-black transition"
                aria-label="Previous slide"
            >
                <ChevronLeft className="h-6 w-6" />
            </button>

            <button
                className="services-highlights-next absolute right-2 top-1/2 -translate-y-1/2 z-10
                           flex h-[45px] w-[45px] items-center justify-center
                           rounded-full bg-black/60 text-white
                           hover:bg-black transition"
                aria-label="Next slide"
            >
                <ChevronRight className="h-6 w-6" />
            </button>
        </div>
    );
};

export default ServicesHighlightsCarousel;
